import { render } from "./LabBookEntry.vue?vue&type=template&id=548af3ee&scoped=true"
import script from "./LabBookEntry.vue?vue&type=script&lang=js"
export * from "./LabBookEntry.vue?vue&type=script&lang=js"

import "./LabBookEntry.vue?vue&type=style&index=0&id=548af3ee&scoped=true&lang=css"

import exportComponent from "/home/runner/work/biology-microscopy/biology-microscopy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-548af3ee"]])

export default __exports__